import { render, staticRenderFns } from "./TableCellOrderLogs.vue?vue&type=template&id=1f121de2&scoped=true"
import script from "./TableCellOrderLogs.vue?vue&type=script&lang=js"
export * from "./TableCellOrderLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f121de2",
  null
  
)

export default component.exports